/* eslint-disable */
import ApiBaseService from '@/core/ApiBaseService';

const shopTypes = {
  MB: 'MB',
  FL: 'FL',
  CDM_PRT: 'CDM-PRT',
};

const monCompteUrl = (endpoint, type) => {
  if (!type) { throw new Error('missing type in call to mon-compte url'); }
  if (type === shopTypes.MB) {
    const baseUrl = process.env.VUE_APP_MON_COMPTE_MB_BACKEND_URL;
    if (!baseUrl || !baseUrl.length) {
      throw new Error('missing VUE_APP_MON_COMPTE_MB_BACKEND_URL in shopService');
    }
    return `${baseUrl}/${endpoint}`;
  }
  if (type === shopTypes.FL) {
    const baseUrl = process.env.VUE_APP_MON_COMPTE_FL_BACKEND_URL;
    if (!baseUrl || !baseUrl.length) {
      throw new Error('missing VUE_APP_MON_COMPTE_FL_BACKEND_URL in shopService');
    }
    return `${baseUrl}/${endpoint}`;
  }
  if (type === shopTypes.CDM_PRT) {
    const baseUrl = process.env.VUE_APP_MON_COMPTE_CDM_PRT_BACKEND_URL;
    return `${baseUrl}/${endpoint}`;
  }
}

class ShopService extends ApiBaseService {
  constructor(props) {
    super(props);
  }

  get shopTypes() {
    return shopTypes;
  }

  setUserToken(token) {
    super.setUserToken(token);
  }

  async createShop(shopData, shopType) {
    const url = monCompteUrl('createShopByAdmin', shopType);
    const { data } = await this.httpPost(url, shopData);
    return data.data;
  }

  async listShopIntranetUsers(shopId) {
    const { data } = await this.httpGet(monCompteUrl(`listShopIntranetUsers?shopId=${shopId}`, shopTypes.MB));
    return data || [];
  }

  async getIntranetUserPassword(code) {
    const { data } = await this.httpGet(monCompteUrl(`getIntranetUserPassword?codeUser=${code}`, shopTypes.MB));
    return data.password;
  }

  async createShopUser(userProfile, userPassword, syncUser, shopId, shopType) {
    const { data } = await this.httpPost(monCompteUrl('createShopUserByAdmin', shopType), {
      shopId,
      userProfile,
      userPassword,
      syncUser,
    });
    return data || [];
  }

  async getShopInfo(shopId, shopType) {
    const { data } = await this.httpGet(monCompteUrl(`getShopById?shopId=${shopId}`, shopType));
    console.log('SHOP INFO', data);
    if (!data) {
      return { name: '', email: '' };
    }
    return data;
  }

  async listShopUsers(shopId, shopType) {
    const { data } = await this.httpGet(monCompteUrl(`shopUsers?shopId=${shopId}`, shopType));
    return data || [];
  }

  async getShopToken(shopId, shopType) {
    const { data } = await this.httpPost(monCompteUrl('getShopToken', shopType), {
      shopId,
    });
    return data.token;
  }

  // Lists the number of users in all our firebase apps:
  // inventaire, mon compte, reception, etc.
  // In order to check for data consistency.
  async shopUsersStats(shopId, shopType) {
    const { data } = await this.httpGet(monCompteUrl(`getShopSynchronizationStats?id=${shopId}`, shopType))
    return data;
  }

  async listAllShops(shopSource) {
    // Source ->
    // AMC: For Portugal cdm
    // AD: For regular shops in France
    const source = shopSource || 'AD';
    const shopType = source === 'AD' ? shopTypes.MB : shopTypes.CDM_PRT;
    const { data } = await this.httpGet(`${monCompteUrl('listShopByUser', shopType)}?source=${source}`);

    const shops = data.map((shop) => ({
      ...shop,
    }));

    // shops.push({
    //   email: 'gothamcity@marieblachere.fr',
    //   id: '1933',
    //   name: 'Gotham City',
    //   type: shopTypes.MB,
    // });
    //
    // shops.push({
    //   email: 'gothamcity@marieblachere.fr',
    //   id: '1933',
    //   name: 'Gotham City',
    //   type: shopTypes.FL,
    // });
    return shops;
  }
}

export default new ShopService();
